<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      tableTitle="Vendor Zones"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    >
      <div slot="icons" class="btn btn-primary" slot-scope="item" @click="build(item)">
        <i class="fa fa-wrench"></i>
      </div>
    </vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import { createRouteIdHash } from '../../../helpers/RouteHash'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'VendorZoneSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        fields: [
          { header: 'Vendor', prop: item => item.vendor ? `${item.vendor.name} - ${item.vendor.code}` : '' },
          { header: 'Name', prop: item => item.location !== null && item.location.name !== null ? item.location.name : '' }
        ],
        loading: false,
        tableData: [],
        entityName: 'vendor-zone',
        editEntityScreen: 'Admin - Edit/View Vendor Zone',
        shouldSearchForExactMatch: true,
        orderBy: 'vendor'
      }
    },
    methods: {
      build ({item}) {
        this.$router.push({ name: 'Admin - Vendor Zone Builder', params: { id: createRouteIdHash(item.id) } })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// VendorZoneSearchResults.vue?5390240c